import { render, staticRenderFns } from "./AssignmentCellDefault.vue?vue&type=template&id=07fab516&"
import script from "./AssignmentCellDefault.vue?vue&type=script&lang=js&"
export * from "./AssignmentCellDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports